import { EEnvironmentName, EEnvironmentProtocol } from "@devowl-wp/react-frontend";
export const environment = {
    name: EEnvironmentName.Production,
    protocol: EEnvironmentProtocol.https,
    hosts: {
        api: {
            realCookieBanner: `https://rcb.devowl.io`,
            realCookieBannerApiVersion: "1.0.0"
        },
        web: `https://admin.owlinfra.de`
    }
};
